export default "__VITE_ASSET__63fc385a__"